/**
 * Returns an array of items based on the current page of pagination.
 * @param {Array.<*>} items - Array of items to paginate.
 * @param {number} perPage - Number of items per page.
 * @param {number} currentPage - Current page number.
 */
export default function getPaginatedList(items, perPage, currentPage) {
  return items?.slice(perPage * (currentPage - 1), perPage * currentPage) ?? [];
}
